import { QueryClient } from '@tanstack/react-query'
import { baseConfig, retryConfig } from './queryConfig'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...baseConfig,
      retry: retryConfig,
      onError: (error) => {
        console.error('Query error:', error);
        
        if (error?.response?.status === 401) {
          localStorage.removeItem('authToken');
        }
      }
    },

    mutations: {
      retry: 1,
      onError: (error) => {
        console.error('Mutation error:', error);
      }
    }
  },
})

export default queryClient;
